import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import CreditInstock from "@perxis-auto/credit-instock";
import { useCreditLimits, useCreditChoice, CreditType } from "@perxis-auto/credit-sdk";
import { isDefined } from "@perxis-auto/shared";
import { useCreditData } from "../../../../features/credit/lib/useCreditData.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../features/credit/model/index.js";
import "@perxis-auto/credit-sdk/lib/internal/entities/credit/lib/formatFinancialPrograms";
import { APP } from "../../../../shared/config/app.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "@perxis-auto/ui-kit/lib/components/Grid";
import "@perxis-auto/ui-kit/lib/components/Typography";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "../../../../shared/store/config/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import "@perxis-auto/ui-kit/lib/components/Loader";
import "../../../../shared/context/constructor.js";
import "../../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import "../../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import "../../../../shared/ui/constructorItem/ConstructorItem.js";
import { FinanceDrawer } from "../../../../shared/ui/financeDrawer/FinanceDrawer.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "@perxis-auto/ui-kit/lib/components/Button";
import "@perxis-auto/ui-kit/lib/components/Icon";
import "@perxis-auto/credit-instock/lib/credit-instock.css";
import styles from "./CreditDrawer.module.scss.js";
const CreditDrawer = memo(function CreditDrawer2({ onClose, vehicleItem }) {
  var _a, _b;
  const { t } = useTranslation(APP.name);
  const { data: creditLimits } = useCreditLimits();
  const {
    actions: { setCreditParameters, setFinancialProgram }
  } = useCreditChoice();
  const creditData = useCreditData(vehicleItem.id);
  const { choice } = creditData;
  if (!vehicleItem || !vehicleItem.data) {
    return null;
  }
  const { price } = vehicleItem.data;
  const model = (_b = (_a = vehicleItem.data) == null ? void 0 : _a.model) == null ? void 0 : _b.displayName;
  if (!model || !price) {
    return null;
  }
  const handleReset = () => {
    if (creditLimits) {
      if (isDefined(choice.type) && isDefined(creditLimits.residualPayment) && choice.type === CreditType.RESIDUAL_PAYMENT) {
        setCreditParameters({
          downPayment: 50,
          numberOfPeriods: 48,
          residualPayment: 25,
          type: CreditType.RESIDUAL_PAYMENT
        });
      } else {
        setCreditParameters({
          downPayment: 50,
          numberOfPeriods: 48,
          residualPayment: null,
          type: CreditType.ANNUITY
        });
      }
    }
    setFinancialProgram({ program: null });
  };
  return /* @__PURE__ */ jsx(FinanceDrawer, { title: t("widgets.finance.creditDrawer.title"), onClose, className: styles.creditDrawer, children: /* @__PURE__ */ jsx(
    CreditInstock,
    {
      onConfirm: onClose,
      onReset: handleReset,
      formatters: {
        payment: (paymentValue) => t("format.currency", { value: paymentValue }),
        period: (period) => t("widgets.finance.creditDrawer.year", { count: period })
      }
    }
  ) });
});
export {
  CreditDrawer
};
